"use client";

import { c as _c } from "react/compiler-runtime";
import { getInlineBadgeClassName, type InlineBadgeVariant } from "@/components/ui/shared-badge-styles";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { ChainInfo } from "../utils/types";
interface ChainBadgeProps {
  chain: ChainInfo;
  /**
   * Size variant for the badge
   * @default "default"
   */
  size?: "sm" | "default";
  variant?: InlineBadgeVariant;
  className?: string;
}

/**
 * ChainBadge - Reusable component to display chain information
 * Shows chain icon, name, and displays chain ID in tooltip
 */
export function ChainBadge(t0) {
  const $ = _c(19);
  const {
    chain,
    size: t1,
    variant: t2,
    className: t3
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const variant = t2 === undefined ? "summary" : t2;
  const className = t3 === undefined ? "" : t3;
  const isSmall = size === "sm";
  let t4;
  if ($[0] !== className || $[1] !== variant) {
    t4 = cn(getInlineBadgeClassName({
      variant,
      className: cn("cursor-help gap-1.5 px-2", className)
    }));
    $[0] = className;
    $[1] = variant;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== chain.iconUrl || $[4] !== chain.name || $[5] !== isSmall) {
    t5 = chain.iconUrl && <img src={chain.iconUrl} alt={chain.name} className={isSmall ? "h-3.5 w-3.5 rounded-full" : "h-4 w-4 rounded-full"} />;
    $[3] = chain.iconUrl;
    $[4] = chain.name;
    $[5] = isSmall;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `font-semibold ${isSmall ? "text-xs" : "text-sm"}`;
  let t7;
  if ($[7] !== chain.name || $[8] !== t6) {
    t7 = <span className={t6}>{chain.name}</span>;
    $[7] = chain.name;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t7) {
    t8 = <TooltipTrigger asChild={true}><div className={t4}>{t5}{t7}</div></TooltipTrigger>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== chain.chainId) {
    t9 = <TooltipContent><p>Chain ID: {chain.chainId}</p></TooltipContent>;
    $[14] = chain.chainId;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <TooltipProvider><Tooltip>{t8}{t9}</Tooltip></TooltipProvider>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}